import { StatePreV5, StateV5 } from './5_migrate_assekuranztarif.interface';

export const migrateAssekuranztarif = (previousState: StatePreV5, newVersion: number): StateV5 => {
  const newState = {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      isAssekuranztarif: previousState.versicherungsnehmer.isFinanzdienstleistertarif,
    },
  };
  delete newState.versicherungsnehmer.isFinanzdienstleistertarif;
  return newState;
};
